var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pickerInput",class:{'color':_vm.textData !== _vm.placeHolder},on:{"click":_vm.clickInput}},[_vm._v(_vm._s(_vm.textData))])}
var staticRenderFns = []

export { render, staticRenderFns }